import { v4 as generateUUID } from 'uuid';
import { Aggregation, Resolution, ResourceType } from '@/clients/dashboardapi/v2';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';
import { Port } from '@/modules/shared/Port';

export default class Windrose implements WidgetPreset {

    public readonly name: string = 'windrose';
    public readonly type: WidgetType = WidgetType.Windrose;
    public readonly quickAdd: boolean = true;
    public readonly order: number = 60;
    public readonly metrics: string[] = [];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            order: 0,
            config: {},
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-month-complete',
            intervalTo: new Date(),
            intervalFrom: new Date(),
            resolution: Resolution.Automatic,
            axis: [{
                unit: '',
                name: '',
                config: {},
                metrics: [{
                    uuid: generateUUID().substring(0, 8),
                    metricName: '',
                    metricKey: '',
                    metricCategory: '',
                    metricUnit: '',
                    aggregationOverTime: Aggregation.None,
                    resources: [{
                        uuid: generateUUID().substring(0, 8),
                        seriesName: '',
                        resourceName: (await Port.portfolios.getPortfolioByKey(params.portfolio))?.name || '',
                        type: ResourceType.Portfolio,
                        resourceKey: params.portfolio,
                        aggregationOverGenerators: Aggregation.None,
                        config: {},
                    }],
                }],
            }],
        };
    }
}
